export default __webpack_public_path__ + "9299f9d59e45124bba79e680627796a0.jpg";